import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthLayout from '../components/AuthLayout';
import RegisterForm from '../components/RegisterForm';
import { USER_TYPES } from '../constants/designer';

export default function Register() {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Bounce an ALREADY signed-in visitor away from /register — but only that.
  //
  // This used to redirect on any truthy `user`, which fired the instant
  // createUserWithEmailAndPassword resolved, i.e. midway through registration
  // and before the profile writes had finished. The user was thrown onto
  // /dashboard, and if a later step failed the rollback then signed them out
  // again — the "dashboard for a second, then login" behaviour.
  //
  // Latching on mount separates "was signed in before this page loaded" from
  // "became signed in because registration is in flight". Completion is
  // reported by RegisterForm's onSuccess instead, which runs only after every
  // step has actually succeeded.
  const wasSignedInOnMount = useRef(Boolean(user));
  useEffect(() => {
    if (wasSignedInOnMount.current && user) navigate('/dashboard', { replace: true });
  }, [user, navigate]);

  return (
    <AuthLayout>
      {/* WHERE A FINISHED SIGN-UP GOES, and it differs by how it finished.
          · A Google or phone sign-up has not been asked customer-or-designer,
            so it goes to that question first. Going straight there beats
            landing on the dashboard and being bounced off it by ProtectedRoute
            a moment later, once the profile has loaded.
          · A CUSTOMER who filled in this form gave a name and a picture but was
            never asked for a location, so they finish their profile in
            Settings — the same page /account-type sends the one-step sign-ins
            to, rather than a second form asking the same things.
          · A designer or a shop filled their whole public profile in on this
            form already, so there is nothing left to ask. */}
      <RegisterForm
        onSuccess={(res) => {
          if (res?.isNewAccount) {
            navigate('/account-type', { replace: true });
          } else if (res?.userType === USER_TYPES.CUSTOMER) {
            navigate('/settings', { replace: true });
          } else {
            navigate('/dashboard', { replace: true });
          }
        }}
      />
    </AuthLayout>
  );
}
